export type BuildCreateAdUnitChangeInput = {
    appId: string;
    displayName: string;
    adFormat: string;
    unitAmount?: string;
    unitType?: string;
};

export function buildCreateAdUnitChange(
    input: BuildCreateAdUnitChangeInput,
): Record<string, unknown> {
    const adFormat = String(input.adFormat || '').trim();
    const change: Record<string, unknown> = {
        appId: String(input.appId || '').trim(),
        displayName: String(input.displayName || '').trim(),
        adFormat,
        adTypes: adFormat === 'REWARDED' ? ['VIDEO'] : ['RICH_MEDIA'],
    };
    if (adFormat === 'REWARDED') {
        change.rewardSettings = {
            unitAmount: String(input.unitAmount || '').trim(),
            unitType: String(input.unitType || '').trim(),
        };
    }
    return change;
}

export type PickAdUnitIdAfterCreateOpts = {
    applyData: unknown;
    units: Array<{
        adUnitId?: string;
        displayName?: string;
        adFormat?: string;
        appId?: string;
    }>;
    displayName: string;
    adFormat: string;
    appId: string;
};

export function pickAdUnitIdAfterCreate(opts: PickAdUnitIdAfterCreateOpts): string {
    const fromApply = String(
        (opts.applyData &&
            typeof opts.applyData === 'object' &&
            (opts.applyData as {adUnitId?: string}).adUnitId) ||
            '',
    ).trim();
    if (fromApply) {
        return fromApply;
    }
    const name = String(opts.displayName || '').trim();
    const format = String(opts.adFormat || '').trim();
    const appId = String(opts.appId || '').trim();
    const match = (opts.units || []).find(
        (u) =>
            String(u.displayName || '').trim() === name &&
            String(u.adFormat || '').trim() === format &&
            (!appId || String(u.appId || '').trim() === appId),
    );
    return String(match?.adUnitId || '').trim();
}
